"use client"

import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { serializeBreadcrumbJsonLd } from "~/components/ui/Breadcrumb/_data/serializer-json-ld"
import InlineCta, { type InlineCtaProps } from "~/components/ui/InlineCta"
import { BreadcrumbData } from "~/components/abstracts/JSONLD/Breadcrumb"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useUSPBannerHeight } from "~/managers/USPBannerManager"

import * as css from "./styles.css"

type BreadcrumbComponentProps = PropsWithClassName<{ items: InlineCtaProps[] }>

function BreadcrumbClient({ className, items }: BreadcrumbComponentProps) {
  const t = useTranslate()
  const [USPBannerHeight] = useUSPBannerHeight()

  return (
    <nav
      aria-label={t("aria_breadcrumb")}
      className={clsx(css.Breadcrumb, className)}
      style={{ top: USPBannerHeight }}
      data-comp="UI/Breadcrumb"
    >
      <ol className={clsx(css.list)}>
        {[{ children: t("general_homepage"), href: "/" }, ...items].map((item, index, baseArray) => {
          const isLast = index === baseArray.length - 1

          return (
            <li key={`breadcrumb_item_${index}`} className={css.item}>
              {!isLast && (
                <>
                  <InlineCta {...item} theme="blue-light" />
                  <span aria-hidden="true" className={clsx(css.separator)}>
                    /
                  </span>
                </>
              )}
              {isLast && <span>{item.children}</span>}
            </li>
          )
        })}
      </ol>
      {items && <BreadcrumbData {...serializeBreadcrumbJsonLd(items)} />}
    </nav>
  )
}

export { BreadcrumbClient, type BreadcrumbComponentProps }
